export function itemRequestStatus(error) {
  return error?.response?.status ?? null
}

export function shouldRetryItems(failureCount, error) {
  const status = itemRequestStatus(error)
  return status !== 401 && status !== 403 && failureCount < 2
}

export const SIGNED_MEDIA_TTL_SECONDS = 180
export const ITEMS_STALE_MS = 10_000

export function itemsRefetchInterval(query) {
  const status = itemRequestStatus(query?.state?.error)
  return status === 401 || status === 403 ? false : 10000
}

export function shouldRenewSignedMedia(fetchedAtMs, nowMs = Date.now(), ttlSeconds = SIGNED_MEDIA_TTL_SECONDS) {
  if (!fetchedAtMs) return true
  const age = Number(nowMs) - Number(fetchedAtMs)
  if (!Number.isFinite(age) || age < 0) return true
  return age >= Math.max(5000, ((Number(ttlSeconds) || SIGNED_MEDIA_TTL_SECONDS) - 30) * 1000)
}

export function nextImageLoadAttempt(retries, hasProductKey) {
  if (Number(retries) >= 1) return 'give_up'
  return hasProductKey ? 'resign' : 'give_up'
}

export function describeItemsState({ isLoading, isPending, isFetching, isSuccess, isPlaceholderData, data, error }) {
  const loaded = Array.isArray(data)
  const status = itemRequestStatus(error)

  if (!loaded) {
    if (error && status === 403) return 'forbidden'
    if (error) return 'error'
    return 'loading'
  }
  if (isPlaceholderData) return loaded && data.length > 0 ? (error ? 'refresh-error' : 'refreshing') : 'loading'
  if (error) return 'refresh-error'
  if (data.length === 0) {
    const confirmedEmpty = isSuccess === true && !isPending && !isLoading
    return confirmedEmpty ? 'empty' : 'loading'
  }
  if (isFetching) return 'refreshing'
  return 'success'
}
